import { NgModule } from '@angular/core';

import { BasePortalHost } from './base-portal-host';
import { DomPortalHost } from './dom-portal-host';
import { ComponentPortal, Portal, PortalHost, PortalInjector, TemplatePortal } from './portal';
import { PortalHostDirective, TemplatePortalDirective } from './portal-directives';
import { PortalFactoryResolver } from './portal-factory-resolver';

@NgModule({
  declarations: [TemplatePortalDirective, PortalHostDirective],
  exports: [TemplatePortalDirective, PortalHostDirective],
})
export class RtUICorePortalModule {}

export {
  Portal,
  PortalHost,
  ComponentPortal,
  TemplatePortal,
  PortalInjector,
  BasePortalHost,
  DomPortalHost,
  PortalHostDirective,
  TemplatePortalDirective,
  PortalFactoryResolver,
};
